// extracted by mini-css-extract-plugin
export var locationCard = "_pu-0";